__turbopack_context__.v({
  "circular-dash": "_1XgxtW_circular-dash",
  "circular-rotate": "_1XgxtW_circular-rotate",
  "root": "_1XgxtW_root",
});
